// SPDX-License-Identifier: AGPL-3.0-or-later

import {makeAutoObservable} from 'mobx';

class ActiveScreenShareSource {
	sourceId: string | null = null;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	setSourceId(sourceId: string | null): void {
		this.sourceId = sourceId;
	}

	getSourceId(): string | null {
		return this.sourceId;
	}

	clear(): void {
		this.sourceId = null;
	}
}

export default new ActiveScreenShareSource();
